// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__bVCL7","opened":"Loader_opened__olrqc","wrapper":"Loader_wrapper__YbMLT","loader":"Loader_loader__j0Tkq","spin":"Loader_spin__8TnK+"};